import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-680f5eb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "third" }
const _hoisted_2 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_panel = _resolveComponent("panel")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_panel, {
      class: "head bg-right-sm",
      bg: true
    }, {
      default: _withCtx(() => [
        _createElementVNode("h1", null, _toDisplayString(_ctx.itemTitle), 1),
        _createElementVNode("h2", null, _toDisplayString(_ctx.Parent), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_panel, {
      class: "columns py-20",
      id: "pageContent"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h3", null, [
            _createVNode(_component_router_link, {
              class: "nav-link",
              to: `/${_ctx.Parent}`
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Parent), 1)
              ]),
              _: 1
            }, 8, ["to"]),
            _createTextVNode(" / " + _toDisplayString(_ctx.itemTitle), 1)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ])
        ])
      ]),
      _: 3
    })
  ]))
}